module.exports = __webpack_public_path__ + "f7e5564a144a70bcdf362b0351e7fddd.pdf";